export default angular
  .module('filters.formatDropoffWindow', [])

  .filter(
    'formatDropoffWindow',
    () =>
      function(dropoffWindow) {
        const windowLabel = dropoffWindow;
        if (windowLabel == null) {
          return '';
        }
        return windowLabel.replace('to', '-');
      },
  );
